<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">需求编号</div>
          <div class="field">
            <el-input v-model.trim="query.demandcode" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">需求名称</div>
          <div class="field">
            <el-input v-model.trim="query.demandname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem" v-if="+user.comtype === 1">
          <div class="label">采购人</div>
          <div class="field">
            <el-input v-model.trim="query.demandcomname" :disabled="pUsernameDisabled" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">创建人</div>
          <div class="field">
            <el-input v-model.trim="query.demandcreateusername" :disabled="pUsernameDisabled" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">采购类别</div>
          <div class="field">
            <el-select v-model="query.demandtype" placeholder="请选择采购类别" clearable>
              <el-option label="货物" value="1"></el-option>
              <el-option label="服务" value="2"></el-option>
              <el-option label="设备" value="3"></el-option>
              <el-option label="货物（设备）" value="4"></el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem" v-if="+user.comtype === 2">
          <div class="label">状态</div>
          <div class="field">
            <el-select v-model="query.demandstatus" :clearable="true" placeholder="请选择">
              <el-option v-for="item in statusDesc" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">建项</div>
          <div class="field">
            <el-select v-model="query.isCreateproject" :clearable="true" placeholder="请选择">
              <el-option label="已建项" :value="1"> </el-option>
              <el-option label="未建项" :value="2"> </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem" v-if="+user.comtype === 2">
          <div class="label">创建日期</div>
          <div class="field" style="width: 400px">
            <el-date-picker v-model="query.begTime" type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"
              placeholder="选择日期"> </el-date-picker>
            <div style="margin: 0 10px">至</div>
            <el-date-picker v-model="query.endTime" type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd"
              placeholder="选择日期"> </el-date-picker>
          </div>
        </div>
        <div class="searchItem" v-if="+user.comtype === 1">
          <div class="label">下达日期</div>
          <div class="field" style="width: 400px">
            <el-date-picker v-model="query.submitbegTime" type="date" format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
            <div style="margin: 0 10px">至</div>
            <el-date-picker v-model="query.submitendTime" type="date" format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type="primary" @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vxe-toolbar perfect v-if="+user.comtype === 2">
      <template v-slot:buttons>
        <vxe-button type="text" status="primary" icon="el-icon-plus" @click="router.push('/jjgl/demandrecAdd')"
          content="新增"></vxe-button>
      </template>
    </vxe-toolbar>
    <vxe-table border highlight-hover-row align="content-center" :loading="loading" :data="list"
      @cell-dblclick="cellClickEvent">
      <vxe-table-column header-align="center" field="projectcode" title="需求编号" width="120">
        <template v-slot="{ row }">
          {{ row.demandcode }}
        </template>
      </vxe-table-column>
      <vxe-table-column header-align="center" field="projectname" title="需求名称" >
        <template v-slot="{ row }">
          <span class="name" @click="router.push('/jjgl/demandrecView?id=' + row.demandid)"> {{ row.demandname }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column header-align="center" field="projectname" title="采购类别" width="80">
        <template v-slot="{ row }">
          {{ row.demandtypename }}
        </template>
      </vxe-table-column>
      <vxe-table-column header-align="center" field="projectname" title="采购人" width="180">
        <template v-slot="{ row }">
          <span> {{ row.comfullname }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column header-align="center" width="120" field="prsflgdesc" title="预算金额（元）">
        <template v-slot="{ row }">
          {{ row.demandbudgetamt | amtDelcommafy }}
        </template>
      </vxe-table-column>
      <vxe-table-column header-align="center" field="sex" :width="+user.comtype === 2 ? 70 : 120" title="状态">
        <template v-slot="{ row }">
          {{ row.statusDesc }}
        </template>
      </vxe-table-column>
      <vxe-table-column header-align="center" field="sex" :width="+user.comtype === 2 ? 70 : 120" title="创建人">
        <template v-slot="{ row }">
          {{ row.demandcreateusername }}
        </template>
      </vxe-table-column>
      <vxe-table-column header-align="center" field="projectlimitamtdesc" title="创建日期" width="100">
        <template v-slot="{ row }">
          {{ formatTime(row.demandcreatetime) }}
        </template>
      </vxe-table-column>
      <vxe-table-column header-align="center" field="comfullname" title="下达日期" width="100">
        <template v-slot="{ row }">
          {{ row.demandsubmittime ? formatTime(row.demandsubmittime) : '' }}
        </template>
      </vxe-table-column>
      <vxe-table-column header-align="center" field="comfullname" title="建项" width="80">
        <template v-slot="{ row }">
          {{ +row.projectcount === 0 ? '未建项' : '已建项' }}
        </template>
      </vxe-table-column>
      <vxe-table-column header-align="center" title="操作" v-if="+user.comtype === 2">
        <template v-slot="{ row }">
          <vxe-button type="text" v-if="+row.demandstatus === 0" status="primary"
            @click="router.push('/jjgl/demandrecEdit?id=' + row.demandid)" content="修改"></vxe-button>
          <vxe-button type="text" @click="deleteClick(row)" v-if="+row.demandstatus === 0" status="primary"
            content="删除"></vxe-button>
          <vxe-button type="text" @click="submitClick(row)" v-if="+row.demandstatus === 0" status="primary"
            content="下达"></vxe-button>
          <vxe-button type="text" @click="router.push('/jjgl/demandrecView?id=' + row.demandid)"
            v-if="+row.demandstatus === 1" status="primary" content="查看"></vxe-button>
        </template>
      </vxe-table-column>
      <vxe-table-column header-align="center" title="操作" width="90" v-else>
        <template v-slot="{ row }">
          <vxe-button type="text" @click="router.push('/jjgl/demandrecView?id=' + row.demandid)"
            v-if="+row.demandstatus === 1" status="primary" content="查看"></vxe-button>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager :loading="loading" :page-sizes="[5, 10, 20, 50, 100]" :current-page="query.currentPage"
      :page-size="query.pageSize" :total="query.total"
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      @page-change="handlePageChange"></vxe-pager>
  </Container>
</template>
<script>
import request from '@/utils/request'
import MenuBtn from '../common/menuBtn'
import vggrid from '../common/vggrid'
import utils from '../../assets/js/utils'
import dayjs from 'dayjs'
import amount from '../common/amount'
import common from '@/mixin/common'
import { mapGetters } from 'vuex'
export default {
  name: 'pbrIndex',
  mixins: [common],
  data() {
    return {
      router: this.$router,
      menuid: this.$route.query.menuid,
      btn: {},
      list: [],
      comform: false,
      project: {},
      com: {},
      loading: true,
      pUsernameDisabled: false,
      query: {
        cosid: this.$store.getters.loginUser.cosid,
        userid: this.$store.getters.loginUser.userid,
        comid: this.$store.getters.loginUser.comid,
        comtype: this.$store.getters.loginUser.comtype,
        total: 0,
        limit: 15,
        offset: 0,
        currentPage: 1,
        pageSize: 15,
      },
      statusDesc: [
        { label: '起草中', value: '0' },
        { label: '已下达', value: '1' },
        { label: '已完成', value: '2' },
        { label: '已终止', value: '3' },
      ],
      roles: [],
      dialogList: [],
      user: this.$store.getters.loginUser
    }
  },
  async activated() {
    await this.getPageList()
  },
  async mounted() {
    await this.getPageList()
    if (+this.$store.getters.loginUser.comtype === 2 && +this.$store.getters.loginUser.roletype === 2) {
      this.query.demandcreateusername = this.$store.getters.loginUser.username
      this.pUsernameDisabled = true
    }
  },
  components: { MenuBtn, vggrid },
  methods: {
    // 双击
    cellClickEvent({ row }) {
      this.router.push('/jjgl/demandrecView?id=' + row.demandid)
    },
    formatTime(value) {
      return dayjs(value).format('YYYY-MM-DD')
    },
    async handlePageChange({ currentPage, pageSize }) {
      this.query.offset = pageSize * (currentPage - 1)
      this.query.limit = pageSize
      this.query.currentPage = currentPage
      this.query.pageSize = pageSize
      await this.getPageList()
    },
    // 下达
    async submitClick(row) {
      const { demandid } = row
      this.$confirm('是否下达该需求', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        let data = await request({
          url: '/xtgl/demandrec/changeStatus',
          method: 'post',
          data: { userid: this.$store.getters.loginUser.userid, demandid, demandstatus: 1 },
        })
        if (data.issuccess === 1) {
          this.$message.success('需求下达成功')
          await this.getPageList()
        } else {
          this.$message.success('需求下达失败')
        }
      })
    },
    // 删除需求
    deleteClick(row) {
      const { demandid } = row
      this.$confirm('是否删除该需求', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        let data = await request({
          url: '/xtgl/demandrec/deleteById',
          method: 'get',
          params: { demandid },
        })
        if (data.issuccess === 1) {
          this.$message.success('需求删除成功')
          await this.getPageList()
        } else {
          this.$message.success('需求删除失败')
        }
      })
    },
    async getPageList() {
      this.loading = true
      this.query.cosid = this.$store.getters.loginUser.cosid
      this.query.userid = this.$store.getters.loginUser.userid
      this.query.comid = this.$store.getters.loginUser.comid
      let comtype = this.$store.getters.loginUser.comtype
      let res = {}
      let roletype = this.$store.getters.loginUser.roletype
      if (+comtype === 1) {
        this.query.isAdmin = 0
        if (+roletype === 1) this.query.isAdmin = 1
        res = await request({
          method: 'get',
          url: '/xtgl/demandrec/getRolePageList',
          params: this.query,
        })
      } else {
        res = await request({
          method: 'get',
          url: '/xtgl/demandrec/getPageList',
          params: this.query,
        })
      }
      this.list = [].concat(res.list)
      this.list = this.list.map((item) => {
        item.statusDesc = this.statusDesc.find((s) => +s.value == +item.demandstatus)?.label
        return item
      })
      this.query.total = res.count[0].count
      this.loading = false
    },
    init() {
      this.query = {
        total: 0,
        limit: 20,
        offset: 0,
        comtype: '',
      }
    },
    async cellClick(row) {
      this.com = row.row
    },

    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1)
      this.query.limit = page.pageSize
      this.getPageList()
    },
    search() {
      this.query.offset = 0
      this.getPageList()
    },
  },
  filters: {
    amtDelcommafy(value) {
      let val = utils.delcommafy(value + '')
      let reg = /^[0-9]+.?[0-9]*$/
      if (reg.test(val)) {
        return utils.getDelcommafyValue(val)
      } else {
        return value
      }
    },
    longDate(value) {
      return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    newDate(value) {
      return dayjs(value).format('YYYY-MM-DD HH:mm:ss SSS')
    },
    qfwVal(value) {
      if (!!value && +value > 0) {
        return utils.comdify(value)
      } else {
        return value
      }
    },
  },
  components: { amount },
  computed: {
    ...mapGetters(['loginUser']),
  },
}
</script>
<style lang="scss">
.name {
  color: #409eff;
  cursor: pointer;
  text-decoration: underline;
}
</style>
